export default __webpack_public_path__ + "static/media/unequal-sa4.9810778f.jpg";